<template>
  <div
    v-if="movie"
    class="movie-details">
    <div class="movie-info">
      <div class="movie-poster">
        <figure class="image">
          <img
            :src="movie.poster.guid"
            :alt="movie['movie-name']"
            :title="movie['movie-name']"
            width="100w">
        </figure>
      </div>
      <div class="movie-info-text">
        <h1 class="movie-title">
          {{ movie['movie-name'] }}
        </h1>
        <div class="movie-meta">
          <span class="year">{{ movie.year }}</span>
          <span class="maturity-rating">{{ movie.rating[0] }}</span>
          <span class="duration">{{ movie.runtime }}</span>
        </div>
        <h2 class="movie-details-title">
          HORARIOS
        </h2>
        <div
          class="movie-showtimes"
          v-html="movie.showtimes"/>
      </div>
    </div>
    <div class="movie-more-info">
      <div class="movie-synopsis">
        <h2 class="movie-details-title">
          Sinopsis
        </h2>
        <div v-html="movie.synopsis"/>
      </div>
      <div class="movie-extra">
        <h2 class="movie-details-title">
          Información Adicional
        </h2>
        <div v-html="movie.details"/>
      </div>
      <div class="movie-media">
        <h2 class="movie-details-title">
          Fotos y Videos
        </h2>
        <figure class="image backdrop">
          <img
            v-if="movie['show-in-carousel'] === '0'"
            :src="movie.backdrop.guid"
            :alt="movie['movie-name']"
            :title="movie['movie-name']"
            width="100w">
          <img
            v-else
            :src="movie.preview.guid"
            :alt="movie['movie-name']"
            :title="movie['movie-name']"
            width="100w">
        </figure>
        <div class="trailer">
          <div class="loader"/>
          <div v-html="modalMovieIframe"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'ModalMovie',
  computed: {
    ...mapState({
      movie: 'movieModal',
    }),
    ...mapGetters({
      modalMovieIframe: 'modalMovieIframe',
    }),
  },
  updated() {
    this.$parent.$parent.$refs.modalMovie.$el.querySelector('.modal-content').scrollTop = 0;
  },
};
</script>
